module.exports = __webpack_public_path__ + "static/media/ic_compagons.56d2cf9b.svg";